import React from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../../utils/constants";

const calculateAdjustedAgeInMonths = (dob, prematurityWeeks) => {
  const birthDate = new Date(dob);
  const today = new Date();
  const ageInMonths =
  (today.getFullYear() - birthDate.getFullYear()) * 12 + (
  today.getMonth() - birthDate.getMonth()) + (
  today.getDate() >= birthDate.getDate() ? 0 : -1);
  const chronologicalAgeMonths = Math.max(ageInMonths, 0);
  const prematurityWeeksInt = parseInt(prematurityWeeks, 10) || 0;
  const isUnderTwoYearsOld = chronologicalAgeMonths < 24;
  if (isUnderTwoYearsOld && prematurityWeeksInt > 3) {
    let effectiveBirthDate = new Date(birthDate);
    const prematurityDays =
    (parseInt(prematurityWeeks, 10) || 0) === 3 ?
    0 :
    (parseInt(prematurityWeeks, 10) || 0) * 7;
    effectiveBirthDate.setDate(effectiveBirthDate.getDate() + prematurityDays);
    let monthAfterPreMaturity =
    (today.getFullYear() - effectiveBirthDate.getFullYear()) * 12 + (
    today.getMonth() - effectiveBirthDate.getMonth()) + (
    today.getDate() >= effectiveBirthDate.getDate() ? 0 : -1);
    return monthAfterPreMaturity;
  }
  return chronologicalAgeMonths;
};

const DependentChildCard = ({ dependent, translationMap, selectedChildId }) => {
  const navigate = useNavigate();
  const handleEditProfile = () => {
    navigate("/editProfile", { state: { childData: dependent } });
  };

  return (
    <div>
      <div
        className="baraem_white_contact_box baraem_white_contact_box_maxwidth2 active"
        style={{
          backgroundColor:
          selectedChildId === dependent.childId ? "#EBF7FF" : "#ffffff"
        }}>
        
        <div className="info_box">
          <span className="icon_box">
            <img
              className="image"
              src={
              dependent.imageProfileBase64 !== "" ?
              `data:image/png;base64,${dependent.imageProfileBase64}` :
              `${config.assestsBase}img/baraem_profile_img.png`
              }
              alt={dependent.name} />
            
          </span>
          <h6 className="MainTitleOne">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href="#"
              style={{
                wordBreak: "break-word"
              }}>
              
              {dependent.name}
            </a>
          </h6>
        </div>
        <div className="baraemDependentCard">
          <div className="age_info">
            <p>
              <b>
                {translationMap?.age ?? "Age"}
                {":"}{" "}
              </b>
              {calculateAdjustedAgeInMonths(
                dependent.dob,
                dependent.prematurity
              )}{" "}
              {translationMap?.months ?? "months"}
            </p>
          </div>
          <div className="btn_box">
            <button onClick={handleEditProfile} className="edit_btn">
              {translationMap?.editProfileText ?? "Edit Profile"}
            </button>
          </div>
        </div>
      </div>
    </div>);

};

export default DependentChildCard;